import styled from 'styled-components';

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.text.size.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0;
  width: 100%;
  :hover {
    cursor: pointer;
  }
`;
